import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	emailList: {
		listStyle: 'none',
		padding: 0,
		paddingTop: THEME.spacing.md,
		paddingBottom: THEME.spacing.md,
		margin: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxHeight: 200,
		overflowY: 'auto',
	},
	tooltipContent: {
		paddingRight: 0,
	},
	emailItem: {
		paddingRight: THEME.spacing.sm,
	},
	emailCountBadge: {
		color: THEME.colors.primary.main,
		fontWeight: 500,
		marginLeft: THEME.spacing.xs,
		fontSize: 14,
	},
});
